import { render, staticRenderFns } from "./BusinessOrderQuery.vue?vue&type=template&id=5fd00526"
import script from "./BusinessOrderQuery.vue?vue&type=script&lang=js"
export * from "./BusinessOrderQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports